import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        setUser(r.data);
        window.history.replaceState(null, "", "/admin");
        nav("/admin", { state: { user: r.data } });
      } catch {
        setErr(true);
        setTimeout(() => nav("/login"), 1500);
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="grid min-h-screen place-items-center bg-[#FAFAFB]">
      <div className="text-center">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-brand" />
        <p className="mt-4 text-sm text-slate-500">{err ? "No se pudo iniciar sesión, redirigiendo..." : "Verificando tu acceso..."}</p>
      </div>
    </div>
  );
}
